module.exports = __webpack_public_path__ + "img/boy-french.883f6bf7.gif";